import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[800px]">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-600 bg-primary-100 rounded-full mb-3">
            安全通道
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">{contactData.title}</h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-lg mx-auto">{contactData.description}</p>
        </div>

        <div className="bg-background-100 rounded-xl border border-background-200/60 p-6 md:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            {contactData.channels.map((ch) => (
              <div
                key={ch.name}
                className="text-center p-5 rounded-lg bg-background-50 border border-background-200/40"
              >
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                  <i className={`${ch.icon} text-lg`}></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-800 mb-1">{ch.name}</h3>
                <p className="text-xs text-foreground-600">{ch.desc}</p>
              </div>
            ))}
          </div>

          <div className="text-center pt-4 border-t border-background-200/40">
            <p className="text-xs text-foreground-500 mb-1">投稿邮箱</p>
            <span className="text-sm md:text-base font-semibold text-primary-600">{contactData.email}</span>
          </div>
        </div>
      </div>
    </section>
  );
}